const initGrabHeaderDrawer = (
    drawerClass,
    button,
    extraCloseButton,
) => {
    const drawer = document.querySelector(`.grab-header-drawer.${drawerClass}`);
    const drawerWrapper = drawer.querySelector('.grab-header-drawer-wrapper');

    if (!button || !drawer) return;

    const closeDrawer = () => {

        // refs #25908: 検索ドロワ: 検索しないで閉じた時、元の状態に戻す
        const predictiveSearch = drawer.querySelector('grab-predictive-search')
        if (predictiveSearch) {
            predictiveSearch.cancel()
        }

        drawer.classList.remove('menu-open');
        button.classList.remove('menu-open');
        const onTransitionEnd = (e) => {
            if (e.propertyName !== 'transform') return;
            drawerWrapper.removeEventListener('transitionend', onTransitionEnd);
            drawer.classList.remove('drawer-visible');
        };
        drawerWrapper.addEventListener('transitionend', onTransitionEnd);
    };

    const closeOtherDrawers = () => {
        const otherDrawers = document.querySelectorAll(`.grab-header-drawer:not(.${drawerClass})`);
        otherDrawers.forEach((otherDrawer) => {
            if (otherDrawer !== drawer) {
                otherDrawer.classList.remove('menu-open', 'drawer-visible');
            }
        });
    };

    const openDrawer = () => {
        drawer.classList.add('drawer-visible');
        requestAnimationFrame(() => {
            drawer.classList.add('menu-open');
            button.classList.add('menu-open');
        });
    };

    const closeButton = drawerWrapper.querySelector('.button-close');
    if (closeButton) {
        closeButton.addEventListener('click', closeDrawer);
    }
    if (extraCloseButton) {
        extraCloseButton.addEventListener('click', closeDrawer);
    }

    button.addEventListener('click', (e) => {
        if (drawer.classList.contains('menu-open')) {
            closeDrawer();
        } else {
            closeOtherDrawers();
            openDrawer();
        }
        e.preventDefault();
        e.stopPropagation();
    });
    drawer.addEventListener('click', (e) => {
        if (e.target !== drawer) return;
        closeDrawer();
    });
}

(function(){
    const mobileIdentifier = document.querySelector('.grab-header-drawer-mobile-identifier')
    const isMobile = mobileIdentifier.offsetWidth === 0 && mobileIdentifier.offsetHeight === 0
    const triggerButtons = document.querySelectorAll('.grab-header-drawer-trigger')
    triggerButtons.forEach(button => {
        let drawerName = button.dataset.drawerName
        if (!drawerName) {
            if (isMobile) {
                drawerName = button.dataset.mobileDrawerName
            }
            else {
                drawerName = button.dataset.desktopDrawerName
            }
        }
        const drawerClass = `grab-header-drawer-${drawerName}`
        const closeButtonSelector = button.dataset.closeButtonSelector
        const extraCloseButton = closeButtonSelector ? document.querySelector(closeButtonSelector) : undefined
        initGrabHeaderDrawer(drawerClass, button, extraCloseButton)
    });
})();